import AppLayout from '../AppLayout'
import CdcSection from './CdcSection'

export default function CaseDellaComunitaPage() {
  return (
    <AppLayout>
      {({ selectedAmbito, onSelectedAmbitoChange }) => (
        <section className="telemetry-dashboard">
          <div className="telemetry-inner">
            <CdcSection
              selectedAmbitoId={selectedAmbito}
              compareAmbiti={false}
              onSelectedAmbitoChange={onSelectedAmbitoChange}
            />
          </div>
        </section>
      )}
    </AppLayout>
  )
}
